export default __webpack_public_path__ + "alberta-across-therapy-order.a0aae06ec3cd4c263e33.svg";